
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import $ from 'jquery';
import { jsPlumb } from 'jsplumb';
import { v4 as uuidv4 } from 'uuid';
import Flow from './flow';
import _ from 'lodash';
import { ISchemaDataDTO } from 'dto/ISchemaDataDTO';
import { IFlowTriggerDTO } from 'dto/IFlowTriggerDTO';
import { IFlowStartupReferenceDTO } from 'dto/IFlowStartupReferenceDTO';
import difference from 'utils/difference';

// TODO: load schema from FlowTemplateController
@Component({
  name: 'Plumb',
})
export default class Plumb extends Vue {
  flow: Flow;

  @Prop({ required: true, type: Array })
  nodeTypes: ISchemaDataDTO[];

  @Prop({ required: true, type: Array })
  value: any[];

  @Prop({ required: true, type: Array })
  triggers: IFlowTriggerDTO[];

  @Prop({ required: true, type: Array })
  startupTypes: IFlowStartupReferenceDTO[];

  offset = 0;

  @Watch('value')
  onValueChanged(val, prevVal) {
    if (this.flow) {
      this.flow.createFlow(val, this.triggers, '.flowContainer');
      this.adjustHeight();
    }
  }

  @Watch('triggers')
  onTriggerChanged(val) {
    if (this.flow) {
      this.flow.createFlow(this.value, val, '.flowContainer');
      this.adjustHeight();
    }
  }

  async mounted() {
    this.flow = new Flow($, jsPlumb, this.nodeTypes);
    await this.flow.init(this.handleDragEnd, this.handleConnectionAttached, this.handleConnectionDetached, this.handleNodeClick, this.handleTriggerStartStepChanged, this.handleNodeTriggerClick, this.handleNodeValidationErrorCallback, this.handleDoubleClickNode);
    this.flow.createFlow(this.value, this.triggers, '.flowContainer');
    this.adjustHeight();
  }

  height = 600;

  adjustHeight() {
    const val = this.value.map((n) => n.position[0] + 200);
    // this.height = _.max([...val, 600]);
    console.log(this.height);
  }

  handleNodeValidationErrorCallback(type: string, node) {
    this.$alert(
      this.$t('flowTemplate.validation.avoidLoop', {
        title: node.title,
        name: this.nodeTypes.find((n) => n.name === node.typeName).title,
      }) as string,
      {
        type: 'error',
      },
    );
  }

  handleConnectionAttached(sourceId, targetId, connectionIndex) {
    const foundNode = _.cloneDeep(this.value.find((n) => n.guid === sourceId));
    foundNode.connections[connectionIndex] = targetId;
    this.$emit('input', [...this.value.filter((n) => n.guid !== sourceId), foundNode]);
  }

  handleConnectionDetached(sourceId, targetId) {
    const foundNode = _.cloneDeep(this.value.find((n) => n.guid === sourceId));
    const connectionIndex = foundNode.connections.indexOf(targetId);
    if (connectionIndex > -1) {
      foundNode.connections[connectionIndex] = null;
      this.$emit('input', [...this.value.filter((n) => n.guid !== sourceId), foundNode]);
    }
  }

  handleNodeClick(nodeId) {
    this.$emit(
      'selectedNode',
      this.value.find((n) => n.guid === nodeId),
    );
  }

  handleDoubleClickNode(nodeId) {
    this.$emit(
      'selectedNodeConfiguration',
      this.value.find((n) => n.guid === nodeId),
    );
  }

  handleDragEnd(type, o, position) {
    if (type === 'node') {
      const foundNode = _.cloneDeep(this.value.find((n) => n.guid === o.guid));
      const oldPosition = foundNode.position;
      const newPosition = [position[1], position[0]];
      foundNode.position = [position[1], position[0]];
      this.$emit('input', [...this.value.filter((n) => n.guid !== o.guid), foundNode]);
      this.handleNodeClick(o.guid);
      if (oldPosition[0] === newPosition[0] && oldPosition[1] === newPosition[1]) {
        this.handleDoubleClickNode(foundNode.guid);
      }
    } else {
      const trigger = _.cloneDeep(this.triggers.filter((t) => t.id === o.id)[0]);
      if (trigger) {
        const oldPosition = trigger.position;
        const newPosition = [position[1], position[0]];
        trigger.position = newPosition;
        this.$emit('input-trigger', trigger);
        if (oldPosition[0] === newPosition[0] && oldPosition[1] === newPosition[1]) {
          this.handleNodeTriggerClick(trigger, null);
        }
      }
    }
  }

  handleTriggerStartStepChanged(sourceId: string, triggerId: number, primary: boolean) {
    const trigger = this.triggers.filter((t) => t.id === triggerId)[0];
    if (trigger) {
      this.$emit('input-trigger', {
        ...trigger,
        startupStep: primary ? sourceId : null,
      });
    }
  }

  handleNodeTriggerClick(trigger, event) {
    this.$emit('trigger-edit', trigger);
  }

  primaryNodeChanged(node, primary: boolean) {
    const foundNode = _.cloneDeep(this.value.find((n) => n.guid === node));
    if (foundNode) {
      foundNode.primary = primary;
      this.$emit('input', [...this.value.filter((n) => n.guid !== node).map((n) => ({ ...n, primary: false })), foundNode]);
    }
  }
}
